export default function getOmsUrl() {
  return process.env.GATSBY_OMS_API_ENDPOINT ?? 'https://api.orders.yourdaye.com';
}
